// lazy_load.jsx
import Preloader from "./preloader";
import { Suspense } from "react";

function LazyLoad({ children }) {
    return <Suspense fallback={<Preloader />}>
        {children}
    </Suspense>
}

export default LazyLoad